import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_page",
  "use": "icon-home_page-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-home_page\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12.78,17.9h4.66V10.67L12,6.32,6.56,10.67V17.9h4.66V13.09h1.56Zm6.22.8a.79.79,0,0,1-.78.8H5.78A.79.79,0,0,1,5,18.7V10.28a.81.81,0,0,1,.3-.63l6.22-5a.75.75,0,0,1,1,0l6.22,5a.81.81,0,0,1,.3.63Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol